import _ from 'underscore';

import { ActionTypes } from './actionTypes';
import { populateQuestions, setSessionReducerToSavedSession } from './session.ts';
import { startListeningToActivities } from './grammarActivities';
import { getQuestion } from './questions';

import { Question, } from '../interfaces/questions';
import {
  GRAMMAR_FILL_IN_BLANK_QUESTION_TYPE,
  QuestionApi
} from '../libs/questions_api';
import { GrammarActivityApi } from '../libs/grammar_activities_api';

export const startListeningToQuestions = (activityUID?: string, sessionID?: string) => {
  return (dispatch: Function) => {
    const fetchQuestions = QuestionApi.getAllForType(GRAMMAR_FILL_IN_BLANK_QUESTION_TYPE);

    fetchQuestions.then((questions: Array<Question>) => {
      if (questions) {
        if (sessionID) {
          populateQuestions(GRAMMAR_FILL_IN_BLANK_QUESTION_TYPE, questions)
          dispatch(setSessionReducerToSavedSession(sessionID))
        }
        dispatch({ type: ActionTypes.RECEIVE_FILL_IN_BLANK_QUESTIONS_DATA, data: questions, });
      } else {
        dispatch({ type: ActionTypes.NO_FILL_IN_BLANK_QUESTIONS_FOUND })
      }
    });
  }
}

export const submitNewQuestion = (content: Question, activityID: string) => {
  return (dispatch: Function) => {
    dispatch({ type: ActionTypes.AWAIT_NEW_FILL_IN_BLANK_QUESTION_RESPONSE, });
    QuestionApi.create(GRAMMAR_FILL_IN_BLANK_QUESTION_TYPE, content).then((question) => {
      dispatch({ type: ActionTypes.RECEIVE_NEW_FILL_IN_BLANK_QUESTION_RESPONSE, });
      const questionUID = Object.keys(question)[0];
      dispatch({ type: ActionTypes.DISPLAY_MESSAGE, message: 'Question successfully created!', });

      const activityQuestion = { key: questionUID, questionType: 'fillInBlank' };
      dispatch({ type: ActionTypes.SUBMIT_LESSON_EDIT, cid: activityID, });
      GrammarActivityApi.addQuestion(activityID, activityQuestion).then(() => {
        dispatch({ type: ActionTypes.FINISH_LESSON_EDIT, cid: activityID, });
        dispatch(startListeningToActivities());
        dispatch(startListeningToQuestions());
        dispatch({ type: ActionTypes.DISPLAY_MESSAGE, message: 'Question successfully added to activity!', });
      }).catch((error) => {
        dispatch({ type: ActionTypes.FINISH_LESSON_EDIT, cid: activityID, });
        dispatch({ type: ActionTypes.DISPLAY_ERROR, error: `Add to activity failed! ${error}`, });
      });
    }).catch((error) => {
      dispatch({ type: ActionTypes.RECEIVE_NEW_FILL_IN_BLANK_QUESTION_RESPONSE, });
      dispatch({ type: ActionTypes.DISPLAY_ERROR, error: `Question creation failed! ${error}`, });
    });
  };
}

export const submitEditedQuestion = (questionUID: string, content: Question) => {
  return (dispatch: Function) => {
    QuestionApi.update(questionUID, content).then(() => {
      dispatch(startListeningToQuestions());
      dispatch({ type: ActionTypes.DISPLAY_MESSAGE, message: 'Question successfully updated!', });
    }).catch((error) => {
      dispatch({ type: ActionTypes.DISPLAY_ERROR, error: `Question update failed! ${error}`, });
    });
  };
}
